/*
 * @Author: your name
 * @Date: 2022-04-07 16:22:59
 * @LastEditTime: 2022-11-23 17:16:55
 * @LastEditors: fyh 18107114013@sina.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /Luckytu-sign-h5/src/router/index.ts
 */
import { createRouter, RouteRecordRaw,createWebHashHistory } from 'vue-router'
import HomeView from '../HomeView.vue'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        redirect:'/TaskView',
        children:[
            {path: '/TaskView',name: 'TaskView',component: () => import('../views/TaskView.vue')},
            {path: '/UploadView',name: 'UploadView',component: () => import('../views/UploadView.vue')},
            {path: '/BankView',name: 'BankView',component: () => import('../views/BankView.vue')},
        ]
    },
    {path: '/ResultView',name: 'ResultView',props:true,component: () => import('../views/ResultView.vue')}
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
